module.exports = __webpack_public_path__ + "img/Jump Casting28.11d33d3a.jpg";